<template>
    <div class="card" @click="goDetail">
         <div class="card-top">
            <div style="font-weight: bold;">
                 {{$DICT.getValue('SNAPSHOT_TYPE', detail.type)}}
            </div>
            <div :style="{color:(detail.state== 'REJECT'?'#F91919':detail.state== 'HANDLE'?'#059B51':'#1989F9'),fontSize:'12px'}">{{$DICT.getValue('SNAPSHOT_STATE', detail.state)}}</div>
         </div>
         <div style="padding: 10px;">
            <div style="color:#999999;">{{detail.describe}}</div>
            <UploadImage 
                
                :imageList="detail.submitImageList"
            />
            <div style="padding: 10px 0;color:#666666;font-size: 12px;">
                <Icon name="location-o" style="top:1px"/>
                {{detail.address}}
            </div>
            <div style="color:#666666;font-size: 12px;">
                <Icon name="clock-o" style="top:1px"/>
                {{detail.createdTime}}
            </div>
         </div>
    </div>
</template>

<script>
import { Icon } from "vant"
import UploadImage from "@/components/UploadImage";

export default {
    components: {
        UploadImage,Icon
    },
    props: {
        detail: {type: Object, default: {}}
    },
    methods:{
        goDetail() {
            this.$router.push({
                name: 'snapshotDetail',
                params: this.detail
            }) 
        }
    }
}
</script>

<style>
    .card {
        background-color: #ffffff;
        margin-bottom: 10px;
    }
    .card-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 10px;
        padding: 10px 0;
        border-bottom: 1px solid #eeeeee;
        
    }
</style>